import { ReactNode } from "react";

interface ResponsiveContainerProps {
  children: ReactNode;
  size?: "sm" | "md" | "lg" | "xl" | "full";
  padding?: "none" | "sm" | "md" | "lg" | "xl";
  className?: string;
}

const ResponsiveContainer = ({ 
  children, 
  size = "lg", 
  padding = "md",
  className = "" 
}: ResponsiveContainerProps) => {
  
  const sizeClasses = {
    sm: "max-w-2xl",
    md: "max-w-4xl",
    lg: "max-w-5xl",  // Standard für Cards/Sections
    xl: "max-w-7xl",
    full: "max-w-full"
  };

  const paddingClasses = {
    none: "px-0",
    sm: "px-4",
    md: "px-4 sm:px-6 lg:px-8",
    lg: "px-6 sm:px-8 lg:px-12",
    xl: "px-8 sm:px-12 lg:px-16"
  };

  return (
    <div className={`container mx-auto ${sizeClasses[size]} ${paddingClasses[padding]} ${className}`}>
      {children}
    </div>
  );
};

export default ResponsiveContainer;
